/**
 * This file is responsible for handling the service calls for the account
 */
import store from "../store";
import {
	callAPI,
	chameau,
	DEFAULT_LIST_PARAMS,
	GATEWAY_PROXY,
	METHODS,
} from "utils/apiUtils";
import {
	SEGMENT_EVENTS,
	trackSegmentEvent,
} from "assets/js/const/SegmentEvents";

function listAutomationsService(
	options = DEFAULT_LIST_PARAMS,
	successCallback = () => { },
	failureCallback = () => { }
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/workflows",
			method: METHODS.get,
			query: {
				...chameau(options),
				account_id: store.getState().global.account.id,
			},
		},
		successCallback,
		failureCallback
	);
}

function createAutomationService(
	options,
	successCallback = () => { },
	failureCallback = () => { }
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/workflows",
			method: METHODS.post,
			body: options,
			query: { account_id: store.getState().global.account.id },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.AUTOMATION_CREATED, data.data);
			successCallback(data);
		},
		failureCallback
	);
}

function deleteAutomationService(
	options = { id: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { id, ...rest } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/workflows/${id}`,
			method: METHODS.delete,
			query: {
				...chameau(rest),
				account_id: store.getState().global.account.id,
			},
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.AUTOMATION_DELETED, data.data);
			successCallback(data);
		},
		failureCallback
	);
}

function activateAutomationService(
	options = { id: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { id, ...rest } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/workflows/${id}/activate`,
			method: METHODS.post,
			query: { account_id: store.getState().global.account.id },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.AUTOMATION_ACTIVATED, data);
			successCallback(data);
		},
		failureCallback
	);
}

function deactivateWorkflow(
	options = { id: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { id, ...rest } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/workflows/${id}/deactivate`,
			method: METHODS.post,
			query: { account_id: store.getState().global.account.id },
		},
		successCallback,
		failureCallback
	);
}

function getAutomationService(
	options = { automationId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { automationId, ...rest } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/workflows/${automationId}`,
			method: METHODS.get,
			query: { account_id: store.getState().global.account.id },
		},
		successCallback,
		failureCallback
	);
}

function patchAutomationService(
	options,
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { automation, automationId, ...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/workflows/${automationId}`,
			method: METHODS.patch,
			body: automation,
			query: {
				...chameau(restOptions),
				account_id: store.getState().global.account.id,
			},
		},
		successCallback,
		failureCallback
	);
}

function listActionsService(
	options,
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { automationId, ...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/workflows/${automationId}/actions`,
			method: METHODS.get,
			query: {
				...chameau(restOptions),
				account_id: store.getState().global.account.id,
			},
		},
		successCallback,
		failureCallback
	);
}

function getActionService(
	options = { automationId: "", actionId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { automationId, actionId, ...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/workflows/${automationId}/actions/${actionId}`,
			method: METHODS.get,
			query: {
				...chameau(restOptions),
				account_id: store.getState().global.account.id,
			},
		},
		successCallback,
		failureCallback
	);
}

function patchActionService(
	options = { automationId: "", actionId: "" },
	updatedAction,
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { automationId, actionId, ...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/workflows/${automationId}/actions/${actionId}`,
			method: METHODS.patch,
			body: updatedAction,
			query: {
				...chameau(restOptions),
				account_id: store.getState().global.account.id,
			},
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.AUTOMATION_ACTION_UPDATED, data.data);
			successCallback(data);
		},
		failureCallback
	);
}

function createActionService(
	options = { automationId: "", newAction: {} },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { automationId, newAction, ...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/workflows/${automationId}/actions`,
			method: METHODS.post,
			body: newAction,
			query: {
				...chameau(restOptions),
				account_id: store.getState().global.account.id,
			},
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.AUTOMATION_ACTION_CREATED, data.data);
			successCallback(data);
		},
		failureCallback
	);
}

function deleteActionService(
	options = { actionId: "", workflowId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { actionId, workflowId, ...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/workflows/${workflowId}/actions/${actionId}`,
			method: METHODS.delete,
			query: {
				...chameau(restOptions),
				account_id: store.getState().global.account.id,
			},
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.AUTOMATION_ACTION_DELETED, data.data);
			successCallback(data);
		},
		failureCallback
	);
}

function sendTestActionService(
	options = { actionId: "", workflowId: "", email: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { actionId, workflowId, email, ...restOptions } = options;
	callAPI(
		{
			url:
				GATEWAY_PROXY +
				`/workflows/${workflowId}/actions/${actionId}/send-test`,
			method: METHODS.post,
			body: { email: email },
			query: {
				...chameau(restOptions),
				account_id: store.getState().global.account.id,
			},
		},
		successCallback,
		failureCallback
	);
}

export {
	listAutomationsService,
	deleteAutomationService,
	deactivateWorkflow,
	activateAutomationService,
	createAutomationService,
	getAutomationService,
	patchAutomationService,
	listActionsService,
	getActionService,
	patchActionService,
	createActionService,
	deleteActionService,
	sendTestActionService,
};
